<template>
  <v-content>
    <v-container style="margin-top: 16px">
      <span class="subtitle">Política de privacidad</span>
    </v-container>
  </v-content>
</template>

<script>
export default {
  name: "PaginaPoliticaPrivacidad",

  data: () => ({
  })
};
</script>
